import { useEffect, useState } from "react";
import { api } from "../App";

const DETERMINATIONS_PATH = "/determinations";

export default function LegendCard() {
  const [codes, setCodes] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api
      .get(DETERMINATIONS_PATH)
      .then((res) => {
        if (!cancelled) setCodes(res.data.codes || []);
      })
      .catch(() => {
        if (!cancelled) setCodes([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      data-testid="legend-card"
      className="bg-white border border-border/60 rounded-xl p-6 sm:p-8 shadow-sm"
    >
      <div className="text-xs uppercase tracking-[0.2em] text-[#5B695E] mb-4">Legend</div>
      <h3 className="font-heading text-xl mb-6 text-[#111812]">Determination codes</h3>
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 text-sm">
        {codes.map((c) => (
          <li key={c.code} className="flex items-start gap-3">
            <span className="font-mono text-[11px] font-semibold px-2 py-0.5 rounded bg-[#F4F5F4] text-[#1A3626] shrink-0">
              {c.code}
            </span>
            <span className="text-[#5B695E]">{c.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
